import React, { Fragment } from 'react'
import { PagerButton, Voiceover, Intro } from 'cvs-core'
import img1 from '../../assets/images/U2-T1-1-2a.svg'
import img2 from '../../assets/images/U2-T1-1-2b.svg'
import img3 from '../../assets/images/U2-T1-1-2c.svg'
import img4 from '../../assets/images/U2-T1-1-2d.svg'
import voAudio from '../../assets/vo/CVS-HS-SPM-Prepare-02-01.mp3'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'Read and think about the following questions and reflect on your own experiences.',
}

export default {
  title: 'Vaping and social media',
  path: '/prepare/vaping-and-social-media',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="Vaping and social media"
        direction="Read and think about the following questions and reflect on your own experiences."
      />
      <article>
        <img
          src={img1}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <p className="text-center">
          Have you ever seen an ad on social media about vaping?
        </p>

        <img
          src={img2}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <p className="text-center">
          Has anyone you follow on social media ever posted a picture using an
          e-cigarette?
        </p>

        <img
          src={img3}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <p className="text-center">
          Do you know how to control what you see on social media?
        </p>

        <img
          src={img4}
          alt=""
          className="img-center"
          height="235"
          width="568"
        />
        <p className="text-center">
          Do you know what resources are available to help you or a friend stop
          using e-cigarettes?
        </p>

        <p className="text-center">
          Most teens use some form of social media. It is important to know how
          to control your social media experience as well as how to help you and
          your friends stay vape free. You'll learn more about all of this in
          the module.
        </p>
      </article>

      <PagerButton />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Prepare/VapingAndSocialMedia.js